import React, { useEffect, useMemo } from 'react'
import { INavItem } from '@/component/layout/SideNav/SideNavItem.tsx'
import NotificationNavItem from '@/pages/notification/layout/NotificationNavItem.tsx'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

interface IProps {
    className?: string;
    children?: any

}

interface INavItemNotification extends INavItem {
    tab?: string
}

const NotificationLayout: React.FunctionComponent<IProps> = ({ className, children }) => {
    const { t } = useTranslation()

    const [searchParams, setSearchParams] = useSearchParams()
    const navItems = useMemo(() => {
        const items: INavItemNotification[] = []
        items.push({
            id: 'sos_alert',
            label: t('notification.layout.tab.sos'),
            href: `/notification?tab=sos`,
            tab: 'sos'
        })
        items.push({
            id: 'bio_alert',
            label: t('notification.layout.tab.bio'),
            href: `/notification?tab=bio`,
            tab: 'bio'
        })
        items.push({
            id: 'fall_alert',
            label: t('notification.layout.tab.falldetection'),
            href: `/notification?tab=fall`,
            tab: 'fall'
        })
        return items
    }, [t])


    useEffect(() => {
        const tab = searchParams.get('tab')
        const isValidTab = tab === 'sos' || tab === 'bio' || tab === 'fall'

        if (!isValidTab) {
            const nextSearchParams = new URLSearchParams(searchParams)
            nextSearchParams.set('tab', 'sos')
            setSearchParams(nextSearchParams, { replace: true })
        }
    }, [searchParams, setSearchParams])

    return <>
        <div className={'notification-shell min-w-0'}>
            <div className={'notification-tabs flex overflow-x-auto px-[24px] pt-[24px] gap-[8px] sm:px-[12px] sm:pt-[12px]'}>
                {navItems?.map(item => <NotificationNavItem {...item} key={item?.id} tab={item?.tab} />)}
            </div>
            <div className={`${className}`}>
                {children}
            </div>
        </div>
    </>
}

export default NotificationLayout
